import { Polygon } from './polygon.model';

export class FloorPlan {

    testata: {
        nome_file: string,
        formato_foglio: string,
        scala: number,
        formato_immagine: string,
        docfa: boolean,
        rooms_ok: number,
        rooms_blank: number,
        rooms_unk: number,
        privateKey: string,
        error: string,
        created_by: string,
        cod_ente: string
    };
    poligono: Polygon[];

    constructor() {
        this.testata = null;
        this.poligono = null;
    }
}